import { FW } from './../framework/Framework';
export class AudioManager extends PIXI.utils.EventEmitter {

    static EVENT = {
        AUDIO_COMPELTE: 'audioComplete'
    }

    private currentAudio: PIXI.sound.IMediaInstance;

    private currentAudioUrl: string;

    private delayAudios: Array<any> = [];

    private sequenceEndUrl: string;

    private stopCurrentAudio(): void {
        if (this.currentAudio) {
            this.currentAudio.stop();
            this.currentAudio = null;
        }
        this.currentAudioUrl = null;
    }

    private stopDelayAudio(): void {
        for (let delay of this.delayAudios) {
            delay.disposed = true;
        }
        this.delayAudios = [];
    }

    private playAudioAndStopOthers(info: {url: string, volume: number}): void {
        this.stopDelayAudio();
        this.playAndStoreAudio(info);
    }

    private playAndStoreAudio(info: {url: string, volume: number}): void {
        this.stopCurrentAudio();
        this.currentAudioUrl = info.url;
        this.playAudio(info.url, info.volume).then(audio => {
            //console.log('on audio loaded: ' + url)
            if(this.currentAudioUrl == info.url) {
                //console.log('audio stored');
                this.currentAudio = audio;
                this.currentAudio.on('end', () => {
                    if(this.currentAudio == audio) {
                        this.currentAudio = null;
                        if(info.url == this.sequenceEndUrl) {
                            this.sequenceEndUrl = null;
                            this.emit(AudioManager.EVENT.AUDIO_COMPELTE);
                        }
                    }
                });    
            } else {
                //console.log('cancel audio')
                audio.stop();
            }
        });
    }

    private playAudio(url: string, vol: number): Promise<PIXI.sound.IMediaInstance> {
        console.log('playAudio: ' + url);
        let sound: PIXI.sound.Sound = PIXI.sound.Sound.from({ url: url });
        let audio = sound.play({ volume: vol || 1 });
        if (audio['then']) {
            return audio as Promise<PIXI.sound.IMediaInstance>;
        } else {
            return Promise.resolve(audio as PIXI.sound.IMediaInstance);
        }
    }

    private playAudioSequence(list: Array<any>): void {
        this.stopDelayAudio();
        for (let info of list) {
            this.sequenceEndUrl = info.url;
            this.delayAudios.push(FW.addDelayFunction(this, this.playAndStoreAudio, info, info.delay));
        }
    }

    public stopOthersAndDelayPlayAudio(url: string, delay: number, volume?: number): void {
        this.stopDelayAudio();
        this.stopCurrentAudio();
        this.sequenceEndUrl = url;
        this.delayAudios.push(FW.addDelayFunction(this, this.playAudioAndStopOthers, {url: url, volume: volume}, delay));
    }

    public forceStopAll(): void {
        console.log('forceStopAll()');
        this.stopAll();
        this.emit(AudioManager.EVENT.AUDIO_COMPELTE);
    }

    public stopAll(): void {
        //console.log('audio: stop all');
        this.stopDelayAudio();
        this.stopCurrentAudio();
    }

    public playButtonInterface(buttonType: string): Promise<PIXI.sound.IMediaInstance> {
        if(!this.currentAudio) {
            return this.playAudio('assets/audio/Buttons Interface/FSO5_' + buttonType + '.mp3', 1);
        }
        return Promise.resolve(null);
    }

    public playTipInstructions(list: Array<{ index: string, delay: number, url?: string, volume?: number }>): void {
        this.playAudioSequence(list.map(v => {
            v.url = 'assets/audio/Instructions/FSO5_Instructions_' + v.index + '.mp3';
            return v;
        }));
    }

    public playCoverIntro(list: Array<{ index: number, delay: number, url?: string }>): void {
        this.playAudioSequence(list.map(v => {
            v.url = 'assets/audio/Intro/FSO5_Intro_00' + v.index + '.mp3';
            return v;
        }));
    }

    public getWorldAudioUrl(worldIndex: number, audioIndex: number): string {
        worldIndex++;
        let index: string = '' + audioIndex;
        while (index.length < 3) {
            index = '0' + index;
        }
        return 'assets/audio/World ' + worldIndex + '/FSO5_World' + worldIndex + '_' + index + '.mp3';
    }

}

export const audioManager = new AudioManager();


// WEBPACK FOOTER //
// ./src/objects/AudioManager.ts